<template>
    <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">나의 정기구매 철회</h2>
      <h3 class="rew19_third_title">주문 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>수령인</em>
          <span class="substance">{{viewData.ship_name}}</span>
        </li>
        <li class="type1">
          <em>전화번호</em>
          <span class="substance">{{viewData.ship_tel}}</span>
        </li>
        <li class="type1">
          <em>핸드폰 번호</em>
          <span class="substance">{{viewData.ship_phone}}</span>
        </li>
        <li class="type1">
          <em>결제정보</em>
          <span 
              v-if='$nvl(viewData.payment_typ,"") == AroConst.VALUE_payment_type_account_transfer'
              class="substance">{{$getContentPaymentType(viewData.payment_typ)}} ({{viewData.print_bank_account}})
          </span>
        </li>
        <li class="type1">
          <em>배송일</em>
          <span class="substance">매월 {{viewData.delivery_day}}일</span>
        </li>
        <li class="type1">
          <em>신청일</em>
          <span class="substance">{{viewData.regdate}}</span>
        </li>
        <li class="type1">
          <em>결제일</em>
          <span class="substance">매월 {{viewData.pay_day}}일</span>
        </li>
      </ul>

      <div class="rew19_responsive_btns gepTaye1">
        <a @click="onClickCancel" class="rew19-btn-border">취소</a>
        <a @click="onClickWithdraw" class="rew19-btn-normal">철회하기</a>
      </div>
    </div>
    <!--rew19_contents_inner-->
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "cancelAccount",
  extends: AroBase,
  components: { }, 
  props:{
    aro_no: {
      type: String,
      required: true
    },
  },
  data() { 
    return {     
      //View Data 

      viewData : {
      },
      
      birth : null
    }
  },
  created() {
  },
  mounted() {
    let _this = this;
  },
  methods: {    
    /**
     * JQuery UI
     */
    initUI(){
      
    },
    
    /**
     * Local function
     */
    initData(paramData){
      let _this = this;

      _this.viewData = {
        ...paramData
      };
    },

    //취소
    onClickCancel(){
      this.$emit('cancel');
    },

    //철회 하기
    onClickWithdraw(){
      let _this = this;

      if(!_this.viewData.birth_dt){
        _this.$dialogs.alert("생년월일 정보가 없습니다. 관리자에게 문의 바랍니다.");
        return;
      }

      _this.$emit('doWithdraw', _this.AroConst.VALUE_payment_type_account_transfer, {birth : _this.viewData.birth_dt});
    },

    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    keyUpToNumber(evt){
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");
    },
  }
}
</script>
<style>
a.rew19-btn-border, a.rew19-btn-normal{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/my/aro/cancelAccount.vue